import React from 'react';
import Planet from '../Assets/planet.webp';
import SpaceElement from '../Assets/space-elements.webp'
import SpaceDoge from '../Assets/space-doge.webp'

const About = () => {
  const content = [
    { name: 'About', path: '/about' },
    { name: 'Tokenomics', path: '/services' },
    { name: 'Docs', path: 'https://docs.zkcandyapi.com/' },
    { name: 'ZKcandy.io', path: 'https://zkcandy.io/' }
  ];

  return (
    <main id="about" className="relative overflow-hidden">
      <div className="container mx-auto px-4 py-10 md:py-20 relative z-10 flex flex-col items-center">
        <h1 data-text="About ZKcandy Foundation" className="zk-title text-center text-shadow text-[1.5rem] md:text-[2rem] font-russo uppercase mb-4 md:mb-10 text-white">About ZKcandy Foundation</h1>

        <div className="zk-container space-y-6 md:space-y-8 text-center my-20 text-[1rem] md:text-[1.3rem] max-w-[800px] w-full mx-auto font-semibold leading-[1.4]">
          <img className="absolute w-[180px] md:w-[230px] top-[-30%] lg:top-[-25%] left-[-2%] lg:left-[-15%]" src={SpaceElement} alt="Space Element" />
          <img className="absolute w-[180px] md:w-[300px] bottom-[-34%] md:bottom-[-55%] right-[0%]" src={SpaceDoge} alt="Space Element" />
          <h3 className="font-bold text-[1rem] md:text-[1.5rem] uppercase bg-[#470d91] absolute left-1/2 transform -translate-x-1/2 -top-[70px] text-white p-2 md:p-4 rounded-xl border-2 border-black">Mission Statement</h3>
          <div className="left-dot"></div>
          <div className="right-dot"></div>
          <p>We envision a future where Web3 gaming is accessible to everyone, regardless of their technical expertise or background.</p>
          <p>The ZKcandy Foundation is committed to making this vision a reality by supporting developers, educating users, and engaging the community.</p>
          <p>Through research, grants, and partnerships, we're with developers and gamers every step of the way.</p>
        </div>
      </div>

      <img className="absolute left-1/2 transform -translate-x-1/2 bottom-0  max-h-[400px] w-auto" src={Planet} alt="ZKcandy Planet" />
    </main>
  );
};

export default About;